import React from 'react'
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';



const data = [
  { value: 100, label: 'Audi', color:'#2196f3' },
  { value: 200, label: 'BMW' , color:'#80cbc4'},
  { value: 160, label: 'Lagonda', color:'#1de9b6' },
  { value: 130, label: 'Land Rover', color:'#66bb6a'},
  { value: 150, label: 'Ford', color:'#8bc34a' },
  { value: 120, label: 'Jaguar', color:'#69f0ae' },
];
const sizing = {
  margin: { right: 5 },
  width: 400,
  height: 225,
  legend: { hidden: true },
};
const TOTAL = data.map((item) => item.value).reduce((a, b) => a + b, 0);

const getArcLabel = (params) => {
  const percent = params.value / TOTAL;
  return `${(percent * 100).toFixed(0)}%`;
};

export default function PieArcLabel() {
  return (
    <PieChart
      series={[
        {
          outerRadius: 110,
          data,
          arcLabel: getArcLabel,
        },
      ]}
      sx={{
        [`& .${pieArcLabelClasses.root}`]: {
          fill: 'white',
          fontSize: 14,
        },
      }}
      {...sizing}
    />
  );
}